// src/hooks/useTotalUnreadCount.js

import { useState, useEffect } from 'react';
import { db, auth } from '../config/firebase';
import { collectionGroup, query, where, onSnapshot, doc } from 'firebase/firestore';

export const useTotalUnreadCount = () => {
  const [count, setCount] = useState(0);
  const currentUser = auth.currentUser;

  useEffect(() => {
    if (!currentUser) return;

    let blockedUsersList = [];

    // 1. First, set up a listener to get the current user's block list in real-time.
    const userDocRef = doc(db, 'users', currentUser.uid);
    const unsubscribeUser = onSnapshot(userDocRef, (userDoc) => {
        blockedUsersList = userDoc.data()?.blockedUsers || [];
    });

    // 2. Then, listen for all unread messages as before.
    const messagesRef = collectionGroup(db, 'messages');
    const q = query(
      messagesRef,
      where('receiverId', '==', currentUser.uid),
      where('readAt', '==', null)
    );

    const unsubscribeMessages = onSnapshot(q, (querySnapshot) => {
      // 3. Before setting the count, filter out messages from blocked users.
      const unreadDocs = querySnapshot.docs;
      const filteredDocs = unreadDocs.filter(doc => !blockedUsersList.includes(doc.data().senderId));
      setCount(filteredDocs.length);
    }, (error) => {
      console.error("Error fetching total unread count (check Firestore indexes):", error);
    });

    // 4. Clean up both listeners when the component unmounts.
    return () => {
        unsubscribeUser();
        unsubscribeMessages();
    };
  }, [currentUser]);

  return count;
};